































































































import _ from 'lodash';
import { PageMode } from '@/main/utils/pageMode';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import { genVuexComputeds } from '@/main/pages/editFactory';
import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
import { ScreenSize, EditableStatus } from '@/main/components/constants';
import {SPLIT_SHARE_DETAILS,SERVICE_JOB_COLS,NAME,SERVICE_JOB_SPLIT_BILLING, LABOR_OPERATION, PARTS_LIST, EXT_LO_TABLE, ROW_SAVED, ROW_EDIT_CLICKED} from './constants';
import { DropdownItem, WorkersWithCostCenter } from '@/main/store/@types/dropdown.d';
import { store } from '../store/edit';
import { Row } from '@/main/utils/table';
import { ZAKAZKA_STAV, ZAKAZKA_DRUH } from '../constants';
import { getStavZakazka } from '../utils';
import { openList } from '@/main/router/routerPath';
import { apiProvider } from './api';
import { showAlert } from '@/main/utils/notifications';
import { SERVICE_JOB_DETAILS } from '../pracovniPozice/constants';
import { START_LOADING, END_LOADING } from '@/main/store/listEditTypes';
import { convertToObjects } from '@/main/utils/table';
import { Console } from 'console';
export default EditStoreMixin.extend({
    name: 'ServiceJobDetailsCard',
    components:{
        DmsEditableTable
    },
    data() {
        return{
			commentInput: '',
            screenSize: ScreenSize.TABLET,
            windowWidth: window.innerWidth,
            splitShareDialogHeaderText: SPLIT_SHARE_DETAILS,
			serviceJobCols:SERVICE_JOB_COLS,
			serviceJobId: 0 as number |null,
			serviceJobDescription : '',
			billTo:0 as number|null,
			splitTable:[],
			splitTableKey: '0',
			showSplitSharesDialog: false,
			loading: true,
			canEdit: false,
        }
    },
    computed: {
     ...genVuexComputeds(store),
		serviceJobName(): string {
			return NAME;
		},	
		zakazkaStav(): ZAKAZKA_STAV {
			return getStavZakazka(this.edit);
		},
		shouldDeleteRow(): boolean {
			return (this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA || this.zakazkaStav === ZAKAZKA_STAV.NABIDKA || this.zakazkaStav === ZAKAZKA_STAV.OTEVRENA);
		},
	canEditComments(): boolean {
			return (this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA || this.zakazkaStav === ZAKAZKA_STAV.NABIDKA || this.zakazkaStav === ZAKAZKA_STAV.OTEVRENA);
		},
	},
	props: {
		 storeUri: { type: String, default: null, required:true },

	},
    methods: {
	getLocalizedText(text: string) {
			return this.LocalizePopisPoli(text);
	},
	getWidth() :string {
			return this.windowWidth <= this.screenSize ? ScreenSize.DIALOG_TABLET_WIDTH : ScreenSize.DIALOG_DEFAULT_WIDTH;
	},
	getSplitBillingClass(row:any){
			const idColId: number = this.dependentTables.ServiceJobDetails.cellNames!.ID;
			const rowId:number= row.cells[idColId];
			if(rowId >= 0 && this.isServiceJobSplitBillingAvailableForOrderType())
			{
			  return 'split-billing-cells'
			}
			return '';
	},
	onSplitSharesDialogClosed() {
		this.loading = false;
	},
		isSplitBillingAvailableForOrderType(): boolean {
			return (this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA);
		},
		canEditTableInReleaseMode(): boolean {
			return ((this.isSplitBillingAvailableForOrderType() || this.ZakazkaDruh === ZAKAZKA_DRUH.GARANCE || this.ZakazkaDruh === ZAKAZKA_DRUH.KULANCE)
			&& (this.zakazkaStav === ZAKAZKA_STAV.OTEVRENA || this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA || this.zakazkaStav === ZAKAZKA_STAV.NABIDKA));
		},
	onCommentInput(event: any, row: Row, columnId: number) {
			this.commentInput = event;
			row.cells[columnId] = event;
		},

	async updateRow(rowToUpdate: { tableName: string; updateStatus: EditableStatus; rowId: number; row: any, rowIndex: number }) {
		const serviceJobIdColId: number = this.dependentTables.ServiceJobDetails.cellNames!.SERVICE_JOB_ID;
		const serviceJobId = this.dependentTables.ServiceJobDetails.rows[rowToUpdate.rowIndex].cells[serviceJobIdColId];		
		if (this.zakazkaStav === ZAKAZKA_STAV.UZAVRENA) {
			showAlert({
				message: this.LocalizeChyboveHlasky('OrderIsClosed'),
				title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				options: {
					type: 'info',
				},
			});
			return null;
		}
			if (await this.isAnyServiceJobSplitPartyInvoiced(serviceJobId)) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ServiceJobInvoiced'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				
			this.canEditComments = false;
			this.canEdit=false;
				return null;
				
		}
		else if (await this.getInvoicestatusAndSagaStatus(serviceJobId)) {
			showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotDelete'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			return null;
		}
		else {
			this.showConfirm({
				message:  this.LocalizeChyboveHlasky('SJ_Deletion_Warning'),
				title: this.LocalizeChyboveHlasky('SURE_TO_DELETE_CONFIRM'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
					callback: async (action) => {
						if (action === 'confirm') {
							const JobIdIndex: number = this.dependentTables.ServiceJobDetails.cellNames!.idColumn;
							const Id = this.dependentTables.ServiceJobDetails.rows[rowToUpdate.rowIndex].cells[JobIdIndex]
							this.$store.commit(`${this.storeUri}/${START_LOADING}`);
							await apiProvider.DeleteServiceJob(Id);
							await this.fetchTableData([SERVICE_JOB_DETAILS,LABOR_OPERATION, PARTS_LIST, EXT_LO_TABLE]);
							const serviceJobsData = convertToObjects(this.dependentTables.ServiceJobDetails).map((serviceJob) => ({
                                                    ...serviceJob,
                                                    Id: serviceJob.Id < 0 ? 0 : serviceJob.Id,
                                                    ServiceOrderId: this.ZakazkaId,
                                                    ZakazkaId: this.ZakazkaId,
                                                }));
                   			this.dropdownList.ServiceJobForItems = this.dropdownList.ServiceJobs.filter((x:any) => serviceJobsData.map(data => data.ServiceJobId).includes(x.Value));
							this.$store.commit(`${this.storeUri}/${END_LOADING}`);
						}
					}
				},
			});
		}
	},
	async isAnyServiceJobSplitPartyInvoiced(serviceJobId:number) {
		    this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			const { data: isInvoiced } = await apiProvider.fetchInvoiceStatusOfServiceJobParty(this.ZakazkaId, serviceJobId);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			return isInvoiced;
		},
		async getInvoicestatusAndSagaStatus(serviceJobId:number) {
		    this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			const { data: isInvoiced } = await apiProvider.getInvoicestatusAndSagaStatus(this.ZakazkaId, serviceJobId, this.IsOrderSentToSaga === true);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			return isInvoiced;
		},
	async onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }) {
		 	const serviceJobIdColId: number = this.dependentTables.ServiceJobDetails.cellNames!.SERVICE_JOB_ID;
		 const serviceJobId = this.dependentTables.ServiceJobDetails.rows[rowIndex].cells[serviceJobIdColId];
		if (await this.getInvoicestatusAndSagaStatus(serviceJobId)) {
			showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			return;
		}
			if (await this.isAnyServiceJobSplitPartyInvoiced(serviceJobId)) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ServiceJobInvoiced'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.canEdit = false;
				this.canEditComments = false;
				return;
			}
		if (this.zakazkaStav === ZAKAZKA_STAV.OTEVRENA || this.zakazkaStav === ZAKAZKA_STAV.NABIDKA || this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA)
		{
			const serviceJobIdColId: number = this.dependentTables.ServiceJobDetails.cellNames!.SERVICE_JOB_ID;
			const beforeServiceJobId = this.dependentTables.ServiceJobDetails.rows[rowIndex].cells[serviceJobIdColId];
			if (beforeServiceJobId != null && !this.UpdatedServiceJobIds.includes(beforeServiceJobId)) {
				this.UpdatedServiceJobIds.push(beforeServiceJobId);
			}
				this.canEdit=true;
				this.canEditComments = true;
				return;
		} 
		else
		{
			showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
		}
	},	
	async createRow() {
		if(!this.CanAddPartOrLabour) {
                showAlert({
                        message: this.LocalizeChyboveHlasky('CANNOT_ADD_NEW_ITEM'),
                        title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
                        options: {
                            type: 'info',
                        },
                    });
                    return;
            }
		if(this.isServiceJobSplitBillingAvailableForOrderType() && (this.UzavreniDat==null || this.UzavreniDat === undefined))
		{
		 	this.canEdit=true;
			this.canEditComments = true;
			(this.$refs.editableTable as any).createRow();
		}
		else if(this.UzavreniDat !=null || this.UzavreniDat != undefined)
		{
			 showAlert({
					message: this.LocalizeChyboveHlasky('OrderClosedSJ'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
		}
		else
		{
			 showAlert({
					message: this.LocalizeChyboveHlasky('SJ_Split_Warning_Msg'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
		}
	},
	redirectToSplitBilling(): boolean {
			return (this.zakazkaStav !== ZAKAZKA_STAV.UZAVRENA && this.isEditMode);
	},
	isServiceJobSplitBillingAvailableForOrderType(): boolean {
		return (this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA);
	},
	async ServiceJobAvailableReservation(serviceJobId: number){
			const response = await apiProvider.ServiceJobAvailableReservation(this.ZakazkaId!, serviceJobId);
			return response?.data;			
	
	},
	async cellClick(row: any, column: any, cell: any) {
			if (this.isServiceJobSplitBillingAvailableForOrderType()) {
			const serviceJobIdColId: number = this.dependentTables.ServiceJobDetails.cellNames!.SERVICE_JOB_ID;
			const idColId: number = this.dependentTables.ServiceJobDetails.cellNames!.ID;
			const rowId:number= row.cells[idColId];
			if(rowId<0)
			{
			 showAlert({
					message: this.LocalizeChyboveHlasky('SJ_Save_Record_Warning'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			 return;
			}

			if (this.redirectToSplitBilling() && column === this.dependentTables.ServiceJobDetails.cellNames!.SERVICE_JOB_DESCRIPTION) {
				const serviceJobId = row.cells[serviceJobIdColId];
				const ndServiceJobColIndex = this.dependentTables.ZakazkaNd.cellNames!.SERVICE_JOB_ID!;
				const ppServiceJobColIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.SERVICE_JOB_NAME!;
				const cvServiceJobColIndex: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.SERVICE_JOB_NAME!;
				const isServiceJobTagedLineItem = this.dependentTables.ZakazkaNd.rows.some(r => r.cells[ndServiceJobColIndex] === serviceJobId)
				|| this.dependentTables.ZakazkaPracovniPozice.rows.some(r => Number(r.cells[ppServiceJobColIndex]) === serviceJobId)
				|| this.dependentTables.ZakazkaCiziVykony.rows.some(r => Number(r.cells[cvServiceJobColIndex]) === serviceJobId);
					if (await this.isAnyServiceJobSplitPartyInvoiced(serviceJobId)) {
						// showAlert({
						// 	message: this.LocalizeChyboveHlasky('ServiceJobInvoiced'),
						// 	title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						// 	options: {
						// 		type: 'info',
						// 	},
						// });
						// return null;
						this.canEdit = false;
						this.canEditComments = false;
					}
					/*if (await this.ServiceJobAvailableReservation(serviceJobId))
					{
						showAlert({
							message: this.LocalizeChyboveHlasky('SERVICE_JOB_ASSIGNMENT_VALIDATION'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
					}*/
					const discountedAmount = row.cells[serviceJobIdColId];
					openList(SERVICE_JOB_SPLIT_BILLING, {
						filter: {
							ServiceOrderId: this.ZakazkaId,
							ServiceJobId: serviceJobId,
							Saga2Prp: this.Saga2Prp,
							IsOrderSentToSaga: this.IsOrderSentToSaga,
							FromServiceJobDetails: true,
							OrderStatus: this.zakazkaStav,
							IsServiceJobTagedLineItem: isServiceJobTagedLineItem,
							PrimaryCustomerId : this.ZakaznikId
						},
					}, { ServiceOrderId: this.ZakazkaId, ServiceJobId: serviceJobId, Saga2Prp: this.Saga2Prp, IsOrderSentToSaga: this.IsOrderSentToSaga, 
						FromServiceJobDetails: true, OrderStatus: this.zakazkaStav, IsServiceJobTagedLineItem: isServiceJobTagedLineItem, PrimaryCustomerId : this.ZakaznikId });
				} else if (column === this.dependentTables.ServiceJobDetails.cellNames!.BILL_TO) {
					const serviceJobId = row.cells[serviceJobIdColId];
					this.splitTable = [];
					this.getSplitShareDetails(serviceJobId);
					this.showSplitSharesDialog = true;
				}
			}
	},

	async refresh( tableName: string){
		await this.fetchTableData([tableName]);
	},
	async getSplitShareDetails(serviceJobId: number | null) {
			this.loading = true;
			const response = await apiProvider.getServiceJobSplitDetails(serviceJobId, this.ZakazkaId!);
			this.loading = false;
			this.splitTable = response?.data;
		},
	getServiceJob(row: Row, columnId: number) {
			let result: DropdownItem = this.dropdownList.ServiceJobs.find(
				(item: DropdownItem) => item.Value === parseInt(row.cells[columnId])
			)!;
			return result?.Value;
	},
	
	async onServiceJobChange(selectedServiceJobId: string, columnId: number, updateCol: any, row: Row) {
			let serviceJobIdColId: number = this.dependentTables.ServiceJobDetails.cellNames!.SERVICE_JOB_ID;
			if (this.dependentTables.ServiceJobDetails.rows.find(r=>r.cells[serviceJobIdColId]==selectedServiceJobId)){
			
				 showAlert({
					message: this.LocalizeChyboveHlasky('SJ_Already_Selected_Msg'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			let serviceJobDescriptionColId: number = this.dependentTables.ServiceJobDetails.cellNames!.SERVICE_JOB_DESCRIPTION;
			let billToColId: number = this.dependentTables.ServiceJobDetails.cellNames!.BILL_TO;
			updateCol(selectedServiceJobId, columnId);
			let result: any = this.dropdownList.ServiceJobs.find(
				(item: any) => item.Value === selectedServiceJobId
			)!;
			updateCol(result?.Value, serviceJobIdColId);
			updateCol(result?.Text, serviceJobDescriptionColId);
			this.serviceJobId=result?.Value;
			this.serviceJobDescription=result?.Text;
		},

	async rowSaved({ row: newRow }: { row: Row }) {		
			let serviceJobIdColId: number = this.dependentTables.ServiceJobDetails.cellNames!.SERVICE_JOB_ID;
			const idColId: number = this.dependentTables.ServiceJobDetails.cellNames!.ID;
			const rowId:number= newRow.cells[idColId];	
			if(this.dependentTables.ServiceJobDetails.rows.find(r=>r.cells[serviceJobIdColId]==this.serviceJobId))
			{
				if(rowId<0)
				{
					setTimeout(() => {
						(this.$refs.editableSplitPartyTable as any).createRow();
					}, 500);
					showAlert({
						message: this.LocalizeChyboveHlasky('SJ_Already_Selected_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});				
					return;
				}
				return;
			}
			if(this.serviceJobId===0)
			{
				return;
			}
			
			let serviceJobDescriptionColId: number = this.dependentTables.ServiceJobDetails.cellNames!.SERVICE_JOB_DESCRIPTION;
			let billToColId: number = this.dependentTables.ServiceJobDetails.cellNames!.BILL_TO;
			newRow.cells[serviceJobIdColId] = this.serviceJobId;
			newRow.cells[serviceJobDescriptionColId]= this.serviceJobDescription;
			const billTo=newRow.cells[billToColId];
			if(billTo == null)
				newRow.cells[billToColId]=0;
			this.dependentTables.ServiceJobDetails.rows.push(newRow);
			console.log(newRow);
		},
    }
});
